import { makeAutoObservable, observable } from 'mobx'
import { RootStore } from './RootStore'
import { SuggestionRequestStatus } from 'types'

export interface RequestStatus {
  layerId: string
  articleId: string
  status?: SuggestionRequestStatus
}

export class AiGenerationStore {
  rootStore: RootStore
  jobs = observable.map<number, RequestStatus>()

  constructor(rootStore: RootStore) {
    makeAutoObservable(this)
    this.rootStore = rootStore
  }

  removeJob(requestId: number) {
    this.jobs.delete(requestId)
  }

  upsertJobStatus(requestId: number, status: RequestStatus) {
    this.jobs.set(requestId, status)
  }

  get activeStreamingLayers() {
    const activeStreamingLayers = observable.set<string>()

    this.jobs.forEach((potentialJob) => {
      if (
        potentialJob.status === SuggestionRequestStatus.Pending ||
        potentialJob.status === SuggestionRequestStatus.Processing
      ) {
        activeStreamingLayers.add(potentialJob.layerId)
      }
    })

    return activeStreamingLayers
  }
}
